module.exports = __webpack_public_path__ + "img/round-case.aa46d60b.svg";